module.exports = __webpack_public_path__ + "img/vertical.bd27517c.png";